import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export const generateAsyncLink = (path, args) => {
    return RESTClient.postAuthenticatedObservable(path, args);
};
